// extracted by mini-css-extract-plugin
export const contactUsContainer = "ContactUs-module--contact-us-container--13es2";
export const contactUs = "ContactUs-module--contact-us--11k_s";
export const label = "ContactUs-module--label--2qwwj";
export const labelTravelAgent = "ContactUs-module--label-travel-agent--3mCGX";
export const phoneNumber = "ContactUs-module--phone-number--3HFIS";
export const phoneNumberDisclaimer = "ContactUs-module--phone-number-disclaimer--1BIMv";